/**
 * @file
 * @author
 **/
import {applyMiddleware, createStore, combineReducers} from 'redux'
import thunk from 'redux-thunk';

import home from './Pages/home/reducer';
import blog from './Pages/blog/reducer';
import mycarousel from './Component/MyCarousel/reducer';
import bloglist from './Component/BlogList/reducer';
import bloglisttimeline from './Component/BlogListTimeLine/reducer';
import blogcontent from './Component/BlogContent/reducer';

const reducer = combineReducers({
    home: home,
    blog:blog,
    mycarousel:mycarousel,
    bloglist:bloglist,
    bloglisttimeline:bloglisttimeline,
    blogcontent:blogcontent,
});

export default createStore(reducer, applyMiddleware(thunk));


// WEBPACK FOOTER //
// ./src/Store.js